import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import * as React from 'react';

import { EditButton } from '@/components/form/baseInputs/Button/EditButton';
import { PlusIcon } from '@/components/icons/PlusIcon';

import { Button, ButtonProps } from '../../form/baseInputs/Button';

export interface EditableListItemProps {
  title: string;
  lineTwo?: string | null;
  lineThree?: string | null;
  lineFour?: string | null;
  onEditClick: () => void;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  disabled?: boolean;
}

export function EditableListItem({
  title,
  lineTwo,
  lineThree,
  lineFour,
  onEditClick,
  sx,
  onClick,
  disabled,
}: EditableListItemProps) {
  return (
    <Stack
      sx={sx}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      component="li"
      aria-label={title}
      onClick={onClick}
    >
      <Box mb={1}>
        <Typography variant="title-s">{title}</Typography>
        {lineTwo && <Typography variant="body-xs">{lineTwo}</Typography>}
        {lineThree && (
          <Typography display="block" variant="body-xs">
            {lineThree}
          </Typography>
        )}
        {lineFour && <Typography variant="body-s">{lineFour}</Typography>}
      </Box>
      <Box>
        <EditButton
          disabled={disabled}
          onClick={onEditClick}
          aria-label={`Edit ${title}`}
        />
      </Box>
    </Stack>
  );
}

export type EditableListProps = React.PropsWithChildren<{
  footerButton?: JSX.Element;
}>;

export function EditableList({ footerButton, children }: EditableListProps) {
  return (
    <Box component="section">
      <Box sx={{ p: 0, m: 0 }} component="ul">
        {React.Children.map(children, (child) => child)}
      </Box>
      <Box component="footer" mt={2}>
        {footerButton && footerButton}
      </Box>
    </Box>
  );
}

export type EditableListAddItemButtonProps = Partial<ButtonProps>;

export function EditableListAddItemButton({
  ...buttonProps
}: EditableListAddItemButtonProps) {
  return (
    <Button
      fullWidth
      startIcon={PlusIcon}
      variant="secondary"
      size="sm"
      {...buttonProps}
    />
  );
}
